import React from "react";
import PropTypes from "prop-types";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

const ProjectCard = (props) => {
  return (
    <Card className="project-card-view">
      <Card.Img variant="top" src={props.imgPath} alt="card-img" />
      <Card.Body>
        <Card.Title>
          <b>{props.title}</b>
        </Card.Title>
        <hr />
        <Card.Text>{props.description}</Card.Text>
        <div className="viewbtn">
          <Button variant="primary" href={props.ghLink} target="_blank">
            <b>view</b>
          </Button>
          <Button variant="primary" href={props.git} target="_blank">
            <b>GitHub</b>
          </Button>
        </div>
        {"\n"}
        {"\n"}

        {/* {!props.isBlog && props.demoLink && (
          <Button
            variant="primary"
            href={props.demoLink}
            target="_blank"
            style={{ marginLeft: "10px" }}
          >
            {"Demo"}
          </Button>
        )} */}
      </Card.Body>
    </Card>
  );
};

ProjectCard.propTypes = {
  imgPath: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  ghLink: PropTypes.string.isRequired,
  git: PropTypes.string.isRequired,
  isBlog: PropTypes.bool.isRequired,
  demoLink: PropTypes.string,
};

export default ProjectCard;
